import { mapGetters } from "vuex";
import Velocity from "velocity-animate";

export default {
    props: {
        recordItem: {
            type: String,
            required: true
        },
        record: {
            type: String,
            required: true
        },
        isClicked: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            clicked: this.isClicked
        };
    },
    computed: {
        ...mapGetters(["currentLanguage"])
    },
    watch: {
        isClicked() {
            this.clicked = this.isClicked;
        }
    },
    methods: {
        toggleStarState() {
            try {
                if (localStorage.getItem(this.record)) {
                    this.clicked ? this.removeActiveStar() : this.setActiveStar();

                    this.$root.$emit(`refresh-${this.recordItem}`, this.clicked);
                } else {
                    localStorage.setItem(this.record, "[]");
                    this.toggleStarState();
                }
            } catch (e) {
                console.log("LocalStorage is not available.");
            }
        },
        setActiveStar() {
            let items = JSON.parse(localStorage.getItem(this.record));
            items.push(`${this.recordItem}`);
            localStorage.setItem(this.record, JSON.stringify(items));
            this.clicked = true;
            this.trackToggleStarEvent();
        },
        removeActiveStar() {
            let items = JSON.parse(localStorage.getItem(this.record));
            items = items.filter(w => {
                return w !== `${this.recordItem}`;
            });
            localStorage.setItem(this.record, JSON.stringify(items));
            this.clicked = false;
            this.trackToggleStarEvent();
        },
        trackToggleStarEvent() {
            this.$ga.event({
                eventCategory: "Star",
                eventAction: "Select star"
            });
        },
        // Star button animation hooks
        enter(el, done) {
            Velocity(el, { scale: "0" }, { duration: 10 });
            Velocity(el, { scale: "1.2" }, { duration: 180 });
            Velocity(el, { scale: "1" }, { duration: 170 }, { complete: done });
        },
        leave(el, done) {
            Velocity(el, { scale: "0" }, { duration: 200 }, { complete: done });
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/StarSentenceButton/StarSentenceButton.js